import { pipe, prop, propOr, chain, propEq, filter, any, propSatisfies, find } from 'ramda'

export const productHasMultipleQuantityInDeal = productKey =>
  pipe(
    propOr([], 'RelatedProductGroups'),
    chain(pipe(prop('Products'), find(propEq('ProductKey', productKey)))),
    filter(x => !!x),
    any(propSatisfies(x => x > 1, 'ProductQuantity')),
  )
